import React, { useState, useEffect } from 'react';
import axios from 'axios';
import authHeader from '../services/AuthHeader';
import ViewStatement from './ViewStatement';
import { Grid, Row, Col, Button } from 'react-bootstrap';

const CandidateProfile = (props) => {
  const [candidates, setCandidates] = useState();

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_BASE +
          'candidateprofile/StarId_' +
          props.match.params.id,
        { headers: authHeader() }
      )
      .then((res) => {
        setCandidates(res.data);
      });
  }, []);

  const ShowCandidates = React.memo((candidates) => {
    if (Array.isArray(candidates.candidates)) {
      const listItems = candidates.candidates.map((e) => (
        <React.Fragment key={e.ballotCandidateId || e.starId}>
          <ViewStatement
            StarId={e.starId}
            headingLevel='h2'
            statementHeadingLevel='h3'
          />
          <br />
          <br />
        </React.Fragment>
      ));
      return <div>{listItems}</div>;
    } else {
      return '';
    }
  });

  return (
    <Grid>
      <Row>
        <Col>
          <h1 className='h2'>Candidate Statements</h1>
          <ShowCandidates candidates={candidates} />
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ textAlign: 'center' }}>
            <Button
              onClick={() => {
                window.close();
              }}
            >
              Close This Tab
            </Button>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default CandidateProfile;
